<template>
  <div class="comp-inquiry-statuslabel" :class="[ computedValue ]">
    {{ computedStatus }}
  </div>
</template>

<script>
  export default {
    name: 'InquiryStatusLabel',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      values: {
        type: Object,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      computedValue() {
        return this.values?.status;
      },
      computedStatus() {
        return this.$i18n.t(`inquiries.statuses.${this.computedValue}`) || null;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.comp-inquiry-statuslabel {
  display: inline-block;
  color: $color-white-solid-10;
  @include font-body-tiny-semibold;
  text-transform: uppercase;
  padding: 6px 4px;
  border-radius: $default-border-radius;
  user-select: none;
  pointer-events: none;

  &.open,
  &.progress,
  &.progress_complete,
  &.reviewing,
  &.reviewed,
  &.finished,
  &.anonymizing,
  {
    background-color: $color-signal-orange;
  }
  &.closed, &.anonymized {
    background-color: $color-signal-green;
  }
  &.archived {
    background-color: $color-black-alpha-60;
  }
}
</style>
